// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { Box, useMediaQuery } from '@mui/material';
import DifusionChip from "./DifusionChip";
import Tabla from "../../Componentes/Tabla";
import { useDifusiones } from "../context/DifusionesContext";
import { useBody } from '../../Body/state/BodyContext';
import { ModalGeneral } from '../../Componentes/ModalGeneral';
import { VerDifusion } from "../VerDifusion";

const columns = [
    {
        header: 'Asunto',
        accessorKey: 'asunto',
        cellStyle: {
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            maxWidth: 1
        },
        headerStyle: {
            textAlign: 'center'
        }
    },
    {
        header: 'Remitente',
        accessorKey: 'remitente',
        cellStyle: {
            textAlign: 'center'
        },
        headerStyle: {
            textAlign: 'center'
        }
    },
    {
        header: 'Área',
        accessorKey: 'areaNombre',
        cellStyle: {
            textAlign: 'center'
        },
        headerStyle: {
            textAlign: 'center'
        }
    },
    {
        header: 'Fecha de envío programada',
        accessorKey: 'horaEntregaProgramada',
    },
    {
        header: 'Fecha de envío',
        accessorKey: 'horaEmision'
    },
    {
        header: 'Estado',
        accessorKey: 'estado',
        accessorFn: rowData => <DifusionChip estado={rowData.estadoDescripcion} />,
        cellStyle: {
            textAlign: 'center'
        },
        headerStyle: {
            textAlign: 'center'
        }
    },
];

const responsive = [
    {
        header: 'Asunto',
        accessorKey: 'asunto',
        cellStyle: {
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            maxWidth: 1
        },
        headerStyle: {
            textAlign: 'center'
        }
    },
    {
        header: 'Estado',
        accessorKey: 'estado',
        accessorFn: rowData => <DifusionChip estado={rowData.estadoDescripcion} />,
        cellStyle: {
            textAlign: 'center'
        },
        headerStyle: {
            textAlign: 'center'
        }
    }
];

export default function ListaDeDifusiones() {
    const { obtenerDifusionesByAreas, difusiones, areasUser } = useDifusiones();
    const { setMessage } = useBody();
    const [difusion, setDifusion] = useState();
    const [openModalVer, setOpenModalVer] = useState(false);
    const [loading, setLoading] = useState(false);
    const matches = useMediaQuery('(min-width:1000px)');

    const POLLING_INTERVAL = 20000;
    const TRANSITIONAL_STATES = [3, 4, 6];

    const fetchDifusiones = async (withLoading = true) => {
        if (withLoading) setLoading(true);
        try {
            await obtenerDifusionesByAreas(areasUser);
        } catch (error) {
            console.error("Error al obtener difusiones: ", error);
            setMessage("Hubo un error al traer las difusiones");
        } finally {
            if (withLoading) setLoading(false);
        }
    };

    useEffect(() => {
        fetchDifusiones();
    }, []);

    useEffect(() => {
        const hasTransitional = difusiones.some(d => TRANSITIONAL_STATES.includes(d.estado));
        if (!hasTransitional) return;

        const interval = setInterval(() => {
            if (!openModalVer) fetchDifusiones(false);
        }, POLLING_INTERVAL);

        return () => clearInterval(interval);
    }, [difusiones, openModalVer]);

    const abrirVistaDifusion = async (difusion) => {
        setDifusion(difusion.original);
        setOpenModalVer(true)
    }

    return (
        <Box
            sx={{ padding: matches ? '16px' : '0px' }}
        >
            <>
                <Tabla
                    columns={matches ? columns : responsive}
                    data={difusiones}
                    enableFullScreenToggle={false}
                    state={{ isLoading: loading }}
                    muiTableBodyRowProps={({ row, staticRowIndex, table }) => ({
                        onClick: (event) =>
                            abrirVistaDifusion(row),
                        sx: { cursor: 'pointer' },
                    })}
                    muiTableContainerProps={{ sx: { height: '50vh' } }}
                />

                <ModalGeneral
                    titulo={"Detalles de la Difusión"}
                    Contenido={<VerDifusion onClose={() => setOpenModalVer(false)} difusion={difusion} />}
                    open={openModalVer}
                    onClose={() => setOpenModalVer(false)}
                />
            </>
        </Box >
    );
}
